<header class="header">
    <app-header></app-header>
    <app-toast></app-toast>
    <app-alert></app-alert>
</header>

<main class="main overflow-hidden" [@fadeAnimation]="prepareRoute(outlet)">
    <router-outlet #outlet="outlet"></router-outlet>
</main>
<footer class="footer">
    <app-footer></app-footer>
</footer>
